import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, MenuItem, TextField } from "@mui/material";
import * as EcommerceActions from '../../../redux/actions/ecommerceAction.js';

const AddAttribute = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const stateData = location.state && location.state.stateData;
    console.log("State Data ::: ", stateData)

    const [color, setColor] = useState('');
    const [attributeTitle, setAttributeTitle] = useState(() => {
        if (stateData) {
            if (stateData.title === 'Size') {
                return 'Size';
            } else if (stateData.title === 'Color') {
                return 'Color';
            } else {
                return 'Other';
            }
        } else {
            return '';
        }
    });
    const [otherTitle, setOtherTitle] = useState(stateData ? stateData?.title == 'Size' ? 'Size' : stateData?.title : '');
    const [attributeValue, setAttributeValue] = useState(stateData ? stateData?.values?.join(', ') : '');
    const [inputFieldError, setInputFieldError] = useState({ attributeTitle: '', attributeValue: '', image: '' });

    //* Handle Color Change
    const handleColorChange = (e) => {
        const newColor = e.target.value;
        setColor(newColor);
        setAttributeValue((prev) => {
            const colorsArray = prev ? prev.split(', ') : [];
            if (!colorsArray.includes(newColor)) {
                colorsArray.push(newColor);
            }
            return colorsArray.join(', ');
        });
    };

    //* Handle Input Field : Error
    const handleInputFieldError = (input, value) => {
        setInputFieldError((prev) => ({ ...prev, [input]: value }))
    }

    //! Handle validation
    const handleValidation = () => {
        let isValid = true;

        if (!attributeTitle) {
            handleInputFieldError("attributeTitle", "Please Enter Category Name")
            isValid = false;
        }
        if (!attributeValue) {
            handleInputFieldError("attributeValue", "Please Enter attributeValue")
            isValid = false;
        }

        return isValid;
    };

    //! Handle Submit - Creating Attributes
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            console.log("Attribute Data :: ", { title: attributeTitle !== 'Other' ? attributeTitle : otherTitle, values: attributeValue?.split(', ') })

            if (stateData) {
                const payload = {
                    data: { attributeId: stateData?._id, title: attributeTitle !== 'Other' ? attributeTitle : otherTitle, values: attributeValue?.split(', ') },
                    onComplete: () => navigate("/e-commerce/attribute")
                }

                //! Dispatching API for Updating Attributes
                dispatch(EcommerceActions.updateEcommerceAttribute(payload))
            } else {
                const payload = {
                    data: { title: attributeTitle !== 'Other' ? attributeTitle : otherTitle, values: attributeValue?.split(', ') },
                    onComplete: () => navigate("/e-commerce/attribute")
                }

                //! Dispatching API for Creating Attributes
                dispatch(EcommerceActions.createEcommerceAttribute(payload))
            }
        }
    };

    return (
        <>
            <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
                    <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add Attribute</div>
                    <div onClick={() => navigate("/e-commerce/attribute")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
                </div>

                <Grid container sx={{ alignItems: "center" }} spacing={3}>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            select label="Select" fullWidth
                            name="attributeTitle"
                            value={attributeTitle}
                            error={inputFieldError.attributeTitle ? true : false}
                            helperText={inputFieldError.attributeTitle}
                            onFocus={() => handleInputFieldError("attributeTitle", null)}
                            onChange={(e) => setAttributeTitle(e.target.value)}
                        >
                            <MenuItem value="Size">Size</MenuItem>
                            <MenuItem value="Color">Color</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                        </TextField>
                    </Grid>

                    {attributeTitle === 'Other' && (
                        <Grid item lg={12} sm={12} md={12} xs={12}>
                            <TextField
                                label="Title" variant='outlined' fullWidth
                                name='otherTitle'
                                value={otherTitle}
                                onChange={(e) => setOtherTitle(e.target.value)}
                                error={inputFieldError.otherTitle ? true : false}
                                helperText={inputFieldError.otherTitle}
                                onFocus={() => handleInputFieldError("otherTitle", null)}
                            />
                        </Grid>
                    )}

                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "15px" }} >
                        <TextField
                            label="Value" variant='outlined' fullWidth placeholder="S, M, L, XL"
                            name='attributeValue'
                            value={attributeValue}
                            onChange={(e) => setAttributeValue(e.target.value)}
                            error={inputFieldError.attributeValue ? true : false}
                            helperText={inputFieldError.attributeValue}
                            onFocus={() => handleInputFieldError("attributeValue", null)}
                        />
                        {attributeTitle === 'Color' && <div style={{ minWidth: "25px", maxWidth: "25px", height: "25px" }}>
                            <input onChange={handleColorChange} multiple type="color" style={{ width: "100%", height: "100%", padding: 0, margin: 0 }} />
                        </div>}
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container sx={{ justifyContent: "space-between" }}>
                            <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
                        </Grid>
                    </Grid>
                </Grid>
            </div >
        </>
    );
};

export default AddAttribute;